module.exports = __webpack_public_path__ + "img/dashboard-dark.0098e4c6.svg";